import { Address } from "../Address";
import { Person } from "./Person";
import { Coordinate } from "../buildingTableViewModel";
import { Area, Survey } from ".";
import { Floor } from "./Floor";
import { DocumentState } from "src/app/core/document-list/models/documentState";

export class Building {
  id: string;
  lomKey: string;
  addresses: Address[];
  persons: Person[];
  floorsBelowGround: number = 0;
  floorsAboveGround: number = 0;
  floors: { [floor: number]: Floor };
  buildingType: number;
  coordinates: Coordinate[];
  outsideSurvey: Survey;
  buildingGroupId: string;
  studentHomeCount: number;
  fiberhood: Area;
  block: Area;
  tsaId: string;
  tsaDocumentStatus?: DocumentState;

  constructor(obj: Partial<Building>) {
    Object.assign(this, obj);

    this.floors = obj.floors || {};

    this.buildFloors();
  }

  buildFloors() {
    var newFloors = {};

    this.floorsAboveGround = this.outsideSurvey?.numberOfFloors ?? 0;

    for (let index = this.floorsBelowGround; index > 0; index--)
      if (!this.floors[-index])
        newFloors[-index] = new Floor({
          floorNumber: -index,
          totalNumberOfUnits: 0,
        });
      else newFloors[-index] = this.floors[-index];

    for (let index = 0; index < this.floorsAboveGround; index++)
      if (!this.floors[index])
        newFloors[index] = new Floor({
          floorNumber: index,
          totalNumberOfUnits: 0,
        });
      else newFloors[index] = this.floors[index];

    this.floors = newFloors;
  }

  getMainAddress(): Address {
    return this.addresses.find((a) => a.isMainAddress);
  }

  getMiddleCoordinate(): Coordinate {
    return this.coordinates.find((a) => a.isCoordinatesMiddleBuilding);
  }
}
